// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BsJK","placeholdersHeader":"styles_placeholdersHeader__tCv4U","editorStyle":"styles_editorStyle__21ZPf","placeholdersBox":"styles_placeholdersBox__qvdLa"};